import { ShieldCheck, LockKey, Fire, Timer, Eye } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-foreground/15 mt-20"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-10 grid md:grid-cols-4 gap-8 text-xs font-mono">
        <div className="md:col-span-2">
          <div className="font-display font-bold text-base tracking-tight mb-2">
            EMERGENT
          </div>
          <p className="text-muted-foreground leading-relaxed max-w-md">
            A zero-knowledge pastebin. Your content is encrypted in the browser
            using AES-256-GCM, then re-encrypted server-side with Fernet. We
            never see your plaintext. Ever.
          </p>
        </div>
        <div>
          <div className="label-overline mb-3">Protections</div>
          <ul className="space-y-2 text-muted-foreground">
            <li className="flex items-center gap-2">
              <LockKey size={14} weight="bold" /> Client-side AES-256
            </li>
            <li className="flex items-center gap-2">
              <ShieldCheck size={14} weight="bold" /> Server-side Fernet
            </li>
            <li className="flex items-center gap-2">
              <Fire size={14} weight="bold" /> Burn after reading
            </li>
          </ul>
        </div>
        <div>
          <div className="label-overline mb-3">Lifecycle</div>
          <ul className="space-y-2 text-muted-foreground">
            <li className="flex items-center gap-2">
              <Timer size={14} weight="bold" /> Auto-expiry
            </li>
            <li className="flex items-center gap-2">
              <Eye size={14} weight="bold" /> View limits
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-foreground/15">
        <div className="max-w-6xl mx-auto px-6 md:px-8 py-4 flex items-center justify-between text-[10px] font-mono uppercase tracking-[0.22em] text-muted-foreground">
          <span>// no logs · no accounts · no tracking</span>
          <span>v0.1.0</span>
        </div>
      </div>
    </footer>
  );
}
